import styled, { css, keyframes } from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import { BonanzaPromoStatus } from '@/modules/promotions/helpers';
import { device } from '@/styles/helpers';

const shine = getCDNImageUrl('/common/shine.webp');

const blinkAnimation = keyframes`
  0% { transform: scale(0); opacity: 0; }
  15% { transform: scale(1.5); opacity: 1; }
  35% { transform: scale(1.5); opacity: 1; }
  100% { transform: scale(0); opacity: 0; }
`;

export const ScPromoStatus = styled.div<{
  status: BonanzaPromoStatus;
  language: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  width: 100%;
  margin-bottom: 32px;
  position: relative;

  & .img-wrapper {
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      inset: 0;
      margin: auto;
      width: 138px;
      height: 138px;
      background: url(${shine});
      background-size: 100%;
      background-repeat: no-repeat;
      animation: ${blinkAnimation} 3s infinite linear;
      z-index: 1;
      pointer-events: none;
    }

    &::before {
      width: 150px;
      height: 150px;
    }
  }

  ${({ status }) =>
    status !== BonanzaPromoStatus.UNLOGGED &&
    status !== BonanzaPromoStatus.PROMO_LOCKED &&
    css`
      margin-bottom: 0px;
      & .img-wrapper {
        & .bonanza-img {
          margin-bottom: -115px;
          margin-left: -165px;
          margin-top: 26px;
        }

        &::before {
          left: -245px;
          top: 240px;
        }
        &::after {
          left: -130px;
          top: 215px;
        }
      }

      @media (${device.mobile}) {
        margin-bottom: 26px;
        & .img-wrapper {
          & .bonanza-img {
            margin-bottom: -50px;
            margin-left: -30px;
            margin-top: 63px;
          }
          &::before {
            left: -90px;
            top: 215px;
          }
          &::after {
            left: -10px;
            top: 185px;
          }
        }
      }
    `}

  ${({ status }) =>
    status === BonanzaPromoStatus.UNLOGGED &&
    css`
      margin-bottom: 0px;
      & .img-wrapper {
        & .bonanza-img {
          margin-bottom: -15px;
          margin-left: -165px;
          margin-top: 25px;
        }
        &::before {
          left: -245px;
          top: 170px;
        }
        &::after {
          left: -130px;
          top: 135px;
        }
      }
      @media (${device.mobile}) {
        margin-bottom: 50px;
        & .img-wrapper {
          & .bonanza-img {
            margin-bottom: -65px;
            margin-left: -30px;
            margin-top: 63px;
          }
          &::before {
            left: -90px;
            top: 215px;
          }
          &::after {
            left: -10px;
            top: 185px;
          }
        }
      }
    `}

  ${({ status }) =>
    status === BonanzaPromoStatus.PROMO_LOCKED &&
    css`
      margin-bottom: 0px;
      & .img-wrapper {
        &::before,
        &::after {
          display: none;
        }
        & .bonanza-img {
          margin-bottom: -4px;
          margin-left: -156px;
          margin-top: 26px;
        }
      }
      @media (${device.mobile}) {
        margin-bottom: 50px;
        & .img-wrapper {
          & .bonanza-img {
            margin-bottom: -65px;
            margin-left: 25px;
            margin-top: 65px;
          }
        }
      }
    `}

  ${({ status }) =>
    status === BonanzaPromoStatus.LEVEL_4 &&
    css`
      & .img-wrapper {
        & .bonanza-img {
          margin-bottom: -44px;
          margin-top: 42px;
          margin-left: -160px;
        }
        &::before {
          left: -245px;
          top: 170px;
        }
        &::after {
          left: -130px;
          top: 140px;
        }
      }
      @media (${device.mobile}) {
        margin-bottom: 3px;
        & .img-wrapper {
          & .bonanza-img {
            margin-top: 120px;
            margin-bottom: 40px;
            margin-left: -25px;
          }
          &::before {
            left: -90px;
            top: 140px;
          }
          &::after {
            left: -10px;
            top: 125px;
          }
        }
      }
    `}
`;
